<template>
  <v-card v-if="!isIframe">
    <v-navigation-drawer id="core-navigation-drawer" v-model="drawer" :dark="true" app left mini-variant-width="80"
      width="260"
>
      {{ isIframe }}
      <v-list-item one-line>
        <v-list-item-content>
          <v-list-item-title>
            <span class="logo-normal"><img id="body-swaps-logo" src="@/assets/Bodyswaps_WO.svg"></span>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list expand nav>
        <div />
        <template v-for="(item, i) in items">
          <base-item-group v-if="item.children && isItemAuthorisedForRole(item)" :key="`group-${i}`" :item="{
            ...item,
            title: $t(item.title),
          }"
/>
          <base-item v-if="!item.children && isItemAuthorisedForRole(item)" :key="`item-${i}`" :item="{
            ...item,
            title: $t(item.title)
          }"
/>
        </template>
        <v-list-item href="https://support.bodyswaps.co/knowledge" target="_blank">
          <v-list-item-icon><v-icon>mdi-help-circle</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('nav.knowledge-center') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="notLearner" href="https://support.bodyswaps.co/" target="_blank">
         <v-list-item-icon><v-icon>mdi-bookshelf</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('nav.community-portal') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item href="https://bodyswaps.co/request-support" target="_blank">
          <v-list-item-icon><v-icon>mdi-alert</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('nav.request-support') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item href="https://bodyswaps.co/referral-programme" target="_blank">
          <v-list-item-icon><v-icon>mdi-handshake</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('nav.referral-programme') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-for="(item, i) in locales" :key="`locales-${i}`" class="d-lg-none d-xl-flex spacing-mobile">
          <v-list-group :value="item.isActive" style="width: 255px !important" @input="item.isActive = !item.isActive">
            <template v-slot:activator>
              <v-list-item-icon><v-icon>{{ item.title }}</v-icon></v-list-item-icon>
              {{ $t('nav.localise') }}
            </template>
            <v-list-item v-for="(subItem, j) in item.subItems" :key="j" style="margin-left: 25px"
              @click="changeLocale(subItem)"
>
              {{ subItem.name }}
            </v-list-item>
          </v-list-group>
        </v-list-item>
        <v-list-item v-for="(item, index) in accounts" :key="`accounts-${index}`"
          class="d-lg-none d-xl-flex spacing-mobile"
>
          <v-list-group :value="item.isActive" style="width: 255px !important" @input="item.isActive = !item.isActive">
            <template v-slot:activator>
              <v-list-item-icon><v-icon>{{ item.title }}</v-icon></v-list-item-icon>
              {{ $t('nav.profile') }}
            </template>
            <v-list-item v-for="[key, profile] of Object.entries(profiles)" :key="key" style="margin-left: 25px"
              :disabled="isActiveProfile(key)" class="pa-0" @click="setProfile(key)"
>
              {{ profile.account.displayName }}
            </v-list-item>
            <v-list-item style="margin-left: 25px" @click="logout">
              {{ $t('global.logout') }}
            </v-list-item>
          </v-list-group>
        </v-list-item>
        <div />
      </v-list>
    </v-navigation-drawer>
    <div v-show="!drawer">
      <v-app-bar app>
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      </v-app-bar>
    </div>
  </v-card>
</template>

<script>
  import { Roles } from '@/helpers/users.js'
  import { getSupportedLocales } from '@/util/i18n/supported-locales'
  import firebase from 'firebase/app'
  import 'firebase/auth'
  import router from '@/router'
  import { cookies } from '@/util/cookies'

  export default {
    name: 'Navigation',
    data () {
      return {
        isIframe: process.env.VUE_APP_IS_IFRAME && process.env.VUE_APP_IS_IFRAME === 'true',
        drawer: window.screen.width > 1500,
        selectedItem: null,
        loading: false,
        profiles: {},
        locales: [
          {
            title: 'mdi-web',
            isActive: false,
            subItems: getSupportedLocales(),
          },
        ],
        accounts: [
          {
            title: 'mdi-account-circle',
            isActive: false,
            subItems: [],
          },
        ],
        items: [
          {
            icon: 'mdi-shield-account-outline',
            title: 'nav.accounts',
            to: '/admin/accounts',
            roles: [Roles.RESELLER, Roles.SYSADMIN],
          },
          {
            icon: 'mdi-home',
            title: 'nav.learner',
            to: '/admin/learner',
            roles: [Roles.LEARNER, Roles.COACH],
          },
          {
            icon: 'mdi-file-document',
            title: 'nav.documents',
            to: '/admin/documents',
            roles: [Roles.LEARNER, Roles.COACH],
          },
          {
            icon: 'mdi-chart-areaspline',
            title: 'nav.organisation',
            to: '/admin/dashboard',
            roles: [Roles.ADMIN, Roles.SYSADMIN, Roles.RESEARCHER],
          },
          {
            icon: 'mdi-file-multiple',
            title: 'nav.reports',
            roles: [Roles.RESELLER, Roles.SYSADMIN, Roles.RESEARCHER],
            children: [{
                         title: 'Accounts',
                         to: '/admin/reports/accounts',
                         roles: [Roles.RESELLER, Roles.SYSADMIN],
                       },
                       {
                         title: 'Resellers',
                         to: '/admin/reports/resellers',
                         roles: [Roles.SYSADMIN],

                       },
                       {
                         title: 'Global',
                         to: '/admin/reports/global-report',
                         roles: [Roles.SYSADMIN],
                       },
                       {
                         title: 'Data Export',
                         to: '/admin/reports/raw-export',
                         roles: [Roles.SUPER, Roles.RESEARCHER],
                       }],
          },
          {
            icon: 'mdi-account-multiple-plus',
            title: 'nav.users',
            to: '/admin/users',
            roles: [Roles.ADMIN, Roles.SYSADMIN],
          },
          {
            icon: 'mdi-account-group',
            title: 'nav.classes',
            to: '/admin/classes',
            roles: [Roles.COACH, Roles.ADMIN, Roles.SYSADMIN],
          },
          {
            icon: 'mdi-arrange-bring-to-front',
            title: 'nav.integrations',
            to: '/admin/integrations',
            roles: [Roles.ADMIN, Roles.SYSADMIN],
          },
          {
            icon: 'mdi-monitor-cellphone-star',
            title: 'nav.devices',
            to: '/admin/devices',
            roles: [Roles.ADMIN, Roles.SYSADMIN],
          },
          {
            icon: 'mdi-glasses',
            title: 'nav.developer',
            to: '/admin/developer',
            roles: [Roles.DEVELOPER],
          },
          {
            icon: 'mdi-library-outline',
            title: 'nav.catalog',
            to: '/admin/catalog',
            roles: [Roles.DEVELOPER],
          },
        ],
      }
    },

    computed: {
      notLearner () {
        const roles = this.$store.getters.currentUserProfile?.user?.roles ?? []
        const isLearner = (roles.length === 1 && roles[0] === Roles.LEARNER) || roles.length === 0
        return !isLearner
      },
    },

    async mounted () {
      this.loading = true
      const userAuthID = firebase.auth().currentUser && firebase.auth().currentUser.uid
      if (userAuthID) {
        await this.$store.dispatch('fetchUserProfiles', userAuthID)
        this.profiles = this.$store.getters.userProfiles
      }
      this.loading = false
    },


    methods: {
      isItemAuthorisedForRole (item) {
        if (this.$store.getters.isAuthenticated) {
          return (item.roles.some(r => this.$store.getters.currentUserProfile.user.roles.includes(r))) || this.$store.getters.currentUserProfile.user.roles.includes('super')
        } else {
          return false
        }
      },
      changeLocale (subItem) {
        cookies.set('locale', subItem.code)
        this.$i18n.locale = subItem.code
      },
      async setProfile (userid) {
        const currentUserProfile = this.$store.getters.userProfiles[userid]
        this.$store.commit('SET_CURRENT_USER_PROFILE', currentUserProfile)
        cookies.set('currentUserID', userid)
        if (currentUserProfile.user.roles.includes(Roles.SUPER) ||
          currentUserProfile.user.roles.includes(Roles.SUPERADMIN)) {
          router.push({ path: '/admin/accounts' })
        } else if (currentUserProfile.user.roles.includes(Roles.ADMIN)) {
          router.push({ path: '/admin/dashboard' })
        } else {
          router.push({ path: '/admin/learner' })
        }
      },
      isActiveProfile (userid) {
        return userid === this.$store.getters.currentUserProfile.user.id
      },
      async logout () {
        // Clear vars
        this.$store.commit('SET_USER_PROFILES', null)
        this.$store.commit('SET_CONTENT_LIBRARY', null)
        await firebase.auth().signOut()
        router.push('/login')
      },
    },
  }
</script>
<style>
.spacing {
  margin-right: 10px;
}

.spacing-mobile {
  margin-left: -10px;
}
</style>
